import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsArrowdown } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-arrowdown.icon';
import { kzIconsChrono } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-chrono.icon';

export enum RequestOrder {
  ASC = 'ASC' as any,
  DESC = 'DESC' as any
}
@Component({
  selector: 'app-flux-options-order',
  templateUrl: './flux-options-order.component.html',
  styleUrls: ['./flux-options-order.component.scss']
})
export class FluxOptionsOrderComponent {

  @Input() order: RequestOrder = RequestOrder.DESC;
  @Input() disabled = false;

  requestOrder: any = RequestOrder;
  @Output() orderChanged: EventEmitter<RequestOrder> = new EventEmitter<RequestOrder>();

  constructor(
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsArrowdown, kzIconsChrono]);
  }

  toggleOrder() {
    this.order = (this.order === RequestOrder.ASC) ? RequestOrder.DESC : RequestOrder.ASC;
    this.orderChanged.emit(this.order);
  }
}
